import { render, staticRenderFns } from "./AddVendorPage.vue?vue&type=template&id=635d0618&scoped=true&"
import script from "./AddVendorPage.vue?vue&type=script&lang=js&"
export * from "./AddVendorPage.vue?vue&type=script&lang=js&"
import style0 from "./AddVendorPage.vue?vue&type=style&index=0&id=635d0618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d0618",
  null
  
)

export default component.exports